import { Spinner } from '@recipes/ui';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router';
import { useAuth } from '@/lib/auth/auth-provider';

/**
 * Where the API sends the browser after a sign-in through the identity service: the refresh
 * cookie is set, the app only has to pick up its session and go on to where the user wanted.
 */
export function OidcCallbackPage() {
  const { t } = useTranslation();
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const wanted = params.get('returnTo') ?? '/';
    const returnTo = wanted.startsWith('/') && !wanted.startsWith('//') ? wanted : '/';
    void refresh().then((token) => {
      navigate(token ? returnTo : '/login?error=oidc_failed', { replace: true });
    });
  }, [navigate, params, refresh]);

  return (
    <div
      className="flex min-h-[60vh] flex-col items-center justify-center gap-3"
      data-testid="oidc-callback"
    >
      <Spinner className="text-muted-foreground" />
      <p className="text-sm text-muted-foreground">{t('auth.identity.finishing')}</p>
    </div>
  );
}
